<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('参数设置.参数名称')" prop="configName">
        <a-input v-model="form.configName" placeholder="请输入" >
            <locale-field-button
              slot="suffix"
              class="ant-input-suffix-button"
              v-model="form.localeFieldMap['configName']"
              :disabled="!form.configName"
              input-type="input"
              table-name="sys_config"
              table-field="configName"
              :field-value="form.configName"
            />
          </a-input>
      </a-form-model-item>
      <a-form-model-item :label="$t('参数设置.参数分组')" prop="configGroup">
        <a-input v-model="form.configGroup" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item :label="$t('参数设置.参数键名')" prop="configKey">
        <a-input v-model="form.configKey" placeholder="请输入" :disabled="readOnly" />
      </a-form-model-item>
      <a-form-model-item label="参数类型" prop="configType">
        <a-radio-group v-model="form.configType" button-style="solid">
          <a-radio-button v-for="(d, index) in  configTypeOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item :label="$t('参数设置.参数键值')"  v-if="form.configType === '2'" prop="configValue">
        <div class="editor-i18n-wrapper">
          <a-input v-model="form.configValue" type="textarea" placeholder="请输入" />
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['configValue']"
            :disabled="!form.configValue"
            input-type="textarea"
            table-name="sys_config"
            table-field="configValue"
            :field-value="form.configValue"
          />
        </div>
      </a-form-model-item>
      <a-form-model-item :label="$t('参数设置.参数键值')"  v-if="form.configType === '3'" prop="configValue">
        <div class="editor-i18n-wrapper">
          <editor v-model="form.configValue" />
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['configValue']"
            :disabled="!form.configValue"
            input-type="editor"
            table-name="sys_config"
            table-field="configValue"
            :field-value="form.configValue"
          />
        </div>
      </a-form-model-item>
      <a-form-model-item :label="$t('参数设置.参数键值')"  v-if="form.configType === '4'" prop="configValue">
        <!--  图片上传      -->
        <a-upload
          name="configValue"
          listType="picture-card"
          class="avatar-uploader"
          :multiple="false"
          :show-upload-list="false"
          :preview="handlePreview"
          :before-upload="beforeOssUpload"
          :customRequest="coverImgUpload">
          <img
            v-if="form.configValue"
            :src="form.configValue"
            alt="configValue"
            style="height: 102px; width: 102px;"/>
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>


      <a-form-model-item label="系统内置" prop="configSystem">
        <a-radio-group v-model="form.configSystem" button-style="solid">
          <a-radio-button v-for="(d, index) in typeOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('参数设置.备注')" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入备注" type="textarea" allow-clear >
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['remark']"
            :disabled="!form.remark"
            input-type="textarea"
            table-name="sys_config"
            table-field="remark"
            :field-value="form.remark"
          />
        </a-input>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { getConfig, addConfig, updateConfig } from '@/api/system/config'
import Editor from '@/components/Editor'
import {uploadObject, uploadOss} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";

export default {
  name: 'CreateForm',
  props: {
    typeOptions: {
      type: Array,
      required: true
    }
  },
  components: {
    LocaleFieldButton,
    Editor
  },
  data () {
    return {
      sysLangList:[],
      loading: null,
      submitLoading: false,
      formTitle: '',
      configTypeOptions: [{"value":"2","label":"文本"},{"value":"3","label":"富文本"},{"value":"4","label":"图片"}],
      // 表单参数
      form: {
        id: undefined,
        configName: undefined,
        configGroup: undefined,
        configKey: undefined,
        configValue: "",
        configSystem: 'Y',
        configLocale: 'N',
        configType: "2",
        remark: undefined,
        localeFieldMap:{},
      },
      readOnly: false,
      open: false,
      rules: {
        configName: [{ required: true, message: '参数名称不能为空', trigger: 'blur' }],
        configGroup: [{ required: true, message: '参数名称不能为空', trigger: 'blur' }],
        configKey: [{ required: true, message: '参数键名不能为空', trigger: 'blur' }],
        configValue: [{ required: true, message: '参数键值不能为空', trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
    this.sysLangList = globalThis.$openLangList;
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        id: undefined,
        configName: undefined,
        configGroup: undefined,
        configKey: undefined,
        configValue: '',
        configSystem: 'Y',
        configLocale: 'N',
        configType: "1",
        remark: undefined,
        localeFieldMap:{},
      }
    },
     /** 新增按钮操作 */
    handleAdd () {
      this.reset()
       this.readOnly = false
       this.open = true
      this.formTitle = '添加参数'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.readOnly = true
      const configId = row ? row.id : ids
      getConfig(configId).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改参数'
      })
    },
    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      }else {
        this.handleImagePreview(file);
      }
    },

    async handleVideoPreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewVideoVisible = true
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewUrl = file.url || file.preview
      this.previewImageVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'config'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'configValue', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    // oss 上传结束
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            updateConfig(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addConfig(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.editor-i18n-wrapper {
  position: relative;
}
/* deep selector to reach into child component root */
.editor-i18n-wrapper /deep/ .ant-input-suffix-button.editor-i18n-btn {
  position: absolute !important;
  bottom: 1px;
  right: 8px !important;
  z-index: 3000;
}
</style>